import { Fragment } from 'react';

import { PillCard } from '@playbooks/molecules/cards';
import {
	BlockquoteElement,
	CodeElement,
	HeaderElement,
	ImageElement,
	TabElement,
	TableElement,
	TocElement,
} from '@playbooks/molecules/mdx';
import { TableBody, TableCell, TableHead, TableHeader, TableRow } from '@playbooks/ui/components/table';

import { MdxAlertText } from './mdx-alert-text';

const Alert = props => <aside className='my-6 flex gap-3 rounded-media border bg-surface-hover/50 p-4' {...props} />;
const AlertIcon = props => <span className='mt-0.5 shrink-0 text-foreground-body' {...props} />;
const AlertBody = props => <div className='min-w-0 flex-1' {...props} />;
const Col = props => <div {...props} />;
const Grid = props => <div className='grid gap-4 md:grid-cols-2' {...props} />;
export const mdxDecorators = (components = {}) => {
	return {
		// a: LinkWrapper,
		blockquote: BlockquoteElement,
		h1: props => <HeaderElement size='h1' {...props} />,
		h2: props => <HeaderElement size='h2' {...props} />,
		h3: props => <HeaderElement size='h3' {...props} />,
		h4: props => <HeaderElement size='h4' {...props} />,
		h5: props => <HeaderElement size='h5' {...props} />,
		h6: props => <HeaderElement size='h6' {...props} />,
		img: ImageElement,
		table: TableElement,
		thead: TableHeader,
		tbody: TableBody,
		th: TableHead,
		tr: TableRow,
		td: TableCell,
		pre: CodeElement,
		Alert,
		AlertIcon,
		AlertBody,
		AlertText: MdxAlertText,
		Col,
		Fragment,
		Grid,
		PillCard,
		TabElement,
		...components,
	};
};
export const tocDecorators = (components = {}) => {
	return {
		h1: props => <TocElement size='h1' {...props} />,
		h2: props => <TocElement size='h2' {...props} />,
		h3: props => <TocElement size='h3' {...props} />,
		h4: props => <TocElement size='h4' {...props} />,
		h5: props => <TocElement size='h5' {...props} />,
		h6: props => <TocElement size='h6' {...props} />,
		Fragment: () => null,
		Alert: () => null,
		AlertIcon: () => null,
		AlertBody: () => null,
		AlertText: () => null,
	};
};
